import { Props } from "./Chart";

export { default } from "./Chart";

export type ChartProps = Props;
